const ContactForm = {

	form: null,

	showMessage: (type, message) => {


		let messageBox = ContactForm.form.querySelector('.message')


		messageBox.classList.add(type)
		messageBox.innerHTML = message
		messageBox.classList.add('active')


		setTimeout(() => {
			messageBox.classList.remove('active')
			messageBox.classList.remove(type)
			messageBox.innerHTML = ''
		}, 3*1000);


	},

	submit: (event) => {
		event.preventDefault()

		ContactForm.form = event.currentTarget

		ContactForm.form.classList.add('loading')

		fetch(window.ajax_url, {
			method: 'POST',
			mode: 'same-origin',
			cache: 'no-cache',
			credentials: 'same-origin',
			redirect: 'follow',
			referrer: 'no-referrer',
			body: new FormData(ContactForm.form),
		})
			.then(function (response) {

				return response.text();

			}).then(function (data) {

				data = JSON.parse(data);

				ContactForm.form.classList.remove('loading')

				ContactForm.showMessage((data.success ? 'success' : 'error'), data.data.message)

				ContactForm.form.reset()

			})
			.catch(function (error) {

				console.error(error);

			});


	},
}

